import React from "react";
import PropTypes from "prop-types";
import Textbox from "components/Forms/Elements/Textbox";
import Translate from "helpers/Translate";

function EisenVault({ clientData, fieldValues, onChange, errors }) {
  return (
    <div>
      <div className="form-group my-10">
        <label>Url:</label>
        <Textbox
          type="text"
          placeholder="https://eisenvault.net"
          id="url"
          name="url"
          fieldValue={fieldValues ? fieldValues.url : ""}
          classes="form-input-sm mr-5"
          onChange={e => onChange(e)}
          onReturnKey={e => {}}
          errors={errors}
          errorKey="adapter.url"
          formErrorClass="form-error"
        />
      </div>
      <div className="form-input my-10">
        <label>{Translate({ id: "username" })} :</label>
        <Textbox
          type="text"
          placeholder="admin"
          id="username"
          name="username"
          fieldValue={fieldValues ? fieldValues.username : ""}
          classes="form-input-sm mr-5"
          onChange={e => onChange(e)}
          onReturnKey={e => {}}
          errors={errors}
          errorKey="adapter.username"
          formErrorClass="form-error"
        />
      </div>
      <div className="form-input my-10">
        <label>
          {Translate({ id: "password" })} :{" "}
          {clientData?.users?.length > 0 ? (
            <i>({Translate({ id: "optional" })} )</i>
          ) : null}
        </label>
        <Textbox
          type="password"
          placeholder="******"
          id="password"
          name="password"
          fieldValue={fieldValues ? fieldValues.password : ""}
          classes="form-input-sm mr-5"
          onChange={e => onChange(e)}
          onReturnKey={e => {}}
          errors={errors}
          errorKey="adapter.password"
          formErrorClass="form-error"
        />
        <div className="help">
          {Translate({ id: "password_will_not_be_saved" })}{" "}
        </div>
      </div>
    </div>
  );
}

EisenVault.propTypes = {
  fieldValues: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object
};

export default EisenVault;
